import { IAPIAction } from "us.common/interfaces";
import { DocumentsManager } from "us.collection.input-output/constants";
import { IDocumentsManagerAction } from "us.collection.input-output/interfaces";

export const documentsManager: Readonly<IAPIAction & IDocumentsManagerAction> =
  {
    documentCategories: {
      get: (data) => ({
        type: DocumentsManager.GET_DOCUMENT_CATEGORIES,
        payload: {
          data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: DocumentsManager.GET_DOCUMENT_CATEGORIES_SUCCESS,
        payload: {
          data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: DocumentsManager.GET_DOCUMENT_CATEGORIES_FAIL,
        payload: {
          error,
          isLoading: false,
        },
      }),
    },
    entityInfo: {
      get: (data) => ({
        type: DocumentsManager.GET_ENTITY_DATA,
        payload: {
          data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: DocumentsManager.GET_ENTITY_DATA_SUCCESS,
        payload: {
          data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: DocumentsManager.GET_ENTITY_DATA_FAIL,
        payload: {
          error,
          isLoading: false,
        },
      }),
    },

    caseAssignment: {
      upload: (fileListToUpload, data) => ({
        type: DocumentsManager.ASSIGN_TO_CASE,
        payload: {
          fileListToUpload,
          data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: DocumentsManager.ASSIGN_TO_CASE_SUCCESS,
        payload: {
          data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: DocumentsManager.ASSIGN_TO_CASE_FAIL,
        payload: {
          error,
          isLoading: false,
        },
      }),
    },
    assignedDocuments: {
      reset: (data) => ({
        type: DocumentsManager.RESET_ASSIGNED_DOCUMENTS,
        payload: {
          data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: DocumentsManager.RESET_ASSIGNED_DOCUMENTS_SUCCESS,
        payload: {
          data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: DocumentsManager.RESET_ASSIGNED_DOCUMENTS_FAIL,
        payload: {
          error,
          isLoading: false,
        },
      }),
    },
  };
